<template>
  <div>
    <app-header><org-nav></org-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Formulário de Inscrição</h2>
      </div>

    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import OrgNav from './Nav.vue'

export default {
  name: 'OrgInscricao',
  components: {
    AppHeader,
    OrgNav
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Inscricao.vue?07961784